import { IAudienceSearchConditions } from 'types/api/audience';

export const defaultConditions: IAudienceSearchConditions = {
  and: [],
  or: [],
};
